package one.healthium.profile.ui.food_history

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.onEach
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.domain.user.UserInteractor
import one.healthium.profile.ui.food_history.models.FoodItemUiModel
import one.healthium.profile.ui.food_history.models.FoodLogUiModel
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel

internal class FoodHistoryViewModel(
    private val userInteractor: UserInteractor,
) : BaseViewModel() {

    private val _state = MutableStateFlow(FoodHistoryUiState())
    val state = _state.asStateFlow()

    val uiMessages = UiMessageManager()

    init {
        userInteractor.observeUser()
            .onStart {
                _state.update { state -> state.copy(loading = true) }
            }
            .onEach {
                _state.update { state ->
                    state.copy(
                        loading = false,
                        foodHistory = it.foodLogs.map(FoodLogUiModel.Companion::fromModel)
                    )
                }
            }
            .catch {
                Logger.e("Failed to load user", it)
                uiMessages.add(UiMessage.throwable(it))
            }
            .launch()
    }

    fun onFoodItemDeleteClicked(foodUiModel: FoodItemUiModel) {
        if (foodUiModel.id == null || foodUiModel.dayId == null) {
            return
        }

        launch {
            try {
                _state.update { state ->
                    state.copy(deleteInProgress = state.deleteInProgress + foodUiModel.id)
                }
                userInteractor.removeFood(foodUiModel.dayId, foodUiModel.id)
            } catch (e: Exception) {
                Logger.e("Failed to delete food item", e)
                uiMessages.add(UiMessage.throwable(e))
            } finally {
                _state.update { state ->
                    state.copy(deleteInProgress = state.deleteInProgress - foodUiModel.id)
                }
            }
        }
    }
}